import { CountryOfPassportListClass } from "./countryOfPassportInterface/countryOfPassportListClass";
import type { CountryOfPassportList } from "./countryOfPassportInterface/countryOfPassportListInterface";

export class ResponseCountryOfPassportList {
  status: boolean;

  message: string;

  data: CountryOfPassportList[];

  constructor(data: any) {
    this.status = data.status;
    this.message = data.message;
    this.data = data.data.map(
      (item: CountryOfPassportList) => new CountryOfPassportListClass(item),
    );
  }
}
